// extracted by mini-css-extract-plugin
export default {"wrapper":"_a2feb204","rowContainerWrapper":"_c8e21369","information":"_8f8b5c9b","applePayIconContainer":"_c9aa147b","applePayIcon":"_4d0af7bc"};